import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { Container, Col, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { STORAGE_URL } from "constants";
import { useFetch, useLanguage } from "hooks";
import { Icons } from "components";

const MySwal = withReactContent(Swal);
export default function Footer({ footerLogoReference }) {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const { publicPages, importantLinks, socialMediaLinks } = useSelector(
    (state) => state.app
  ); // call data from app store
  const [_, newsLetterRequest] = useFetch("submitNewsletter", "POST");
  const emailInputRef = React.useRef();

  const handleSubmitNewsLetter = (e) => {
    e.preventDefault();
    newsLetterRequest(
      {
        email: emailInputRef.current.value,
      },
      null,
      () => {
        emailInputRef.current.value = "";
        MySwal.fire({
          icon: "success",
          title: language.submit_success,
          text: language.submit_success_message,
          confirmButtonText: "متابعة",
        });
      },
      (error) => {
        MySwal.fire({
          icon: "error",
          title: language.submit_error,
          text: error.email,
          confirmButtonText: "متابعة",
        });
      }
    );
  };

  return (
    <footer id="footer" className="footer">
      <div
        className="footer_container"
        style={{ backgroundImage: "url(/images/footer-bg.png)" }}
      >
        <div className="pt-4">
          <Container>
            <Row>
              <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                <Row>
                  <Col xs={12}>
                    <Link to="/">
                      <img
                        ref={footerLogoReference}
                        onClick={() => window.scrollTo(0, 0)}
                        src={"/images/logo.svg"}
                        className="logo"
                        title="logo"
                        alt="logo"
                      />
                    </Link>
                  </Col>
                  <Col
                    xl={10}
                    lg={10}
                    md={8}
                    sm={10}
                    xs={10}
                    className="px-0 mx-0 mt-4"
                  >
                    <p className="fw-normal text-light5 mb-2">
                      {language.enterEmailAddressLabel}
                    </p>
                    <form onSubmit={handleSubmitNewsLetter}>
                      <div className="input-group mb-2">
                        <i className="input-group-text bg-white border-0">
                          <Icons.SMS />
                        </i>
                        <input
                          ref={emailInputRef}
                          type="email"
                          className="form-control border-0 py-2"
                          placeholder={language.emailAddress}
                          required={true}
                        />
                        <button
                          type="submit"
                          className="btn btn-primary fw-bold"
                        >
                          {language.subscribe}
                        </button>
                      </div>
                    </form>

                    <ul className="social_media_links d-flex flex-wrap gap-3 list-unstyled mt-4">
                      {socialMediaLinks.data.map((item) => (
                        <li
                          key={item.id}
                          className="filter_hover d-flex align-items-center bg-transparent border-0 p-0"
                        >
                          <a href={item.link} target="_blank" rel="noreferrer">
                            <img
                              src={`${STORAGE_URL}${item.icon}`}
                              alt={item.name}
                            />
                          </a>
                        </li>
                      ))}
                    </ul>
                  </Col>
                </Row>
              </Col>
              <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                <Row className="mt-4 mt-4 mt-4 ">
                  <Col xl={4} lg={4} md={4} sm={6} xs={6} className="mt-4">
                    <h4 className="fw-normal text-black">
                      {language.aboutTheLibrary}
                    </h4>
                    <ul className="list-group">
                      {publicPages.data.map((item) => (
                        <li
                          key={item.id}
                          className="list-group-item bg-transparent  border-0 p-0"
                        >
                          <NavLink
                            to={`/page/${item.machine_name}`}
                            className="link text-decoration-none"
                            href="#test"
                          >
                            {item.title}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </Col>
                  <Col xl={4} lg={4} md={4} sm={6} xs={6} className="mt-4">
                    <h4 className="fw-normal text-black">{language.menu}</h4>
                    <ul className="list-group">
                      <li className="list-group-item bg-transparent  border-0 p-0">
                        <NavLink
                          to="/books"
                          className="link text-decoration-none"
                          href="#test"
                        >
                          {language.books}
                        </NavLink>
                      </li>
                      <li className="list-group-item bg-transparent  border-0 p-0">
                        <NavLink
                          to="/magazines"
                          className="link text-decoration-none"
                          href="#test"
                        >
                          {language.magazines}
                        </NavLink>
                      </li>
                      <li className="list-group-item bg-transparent  border-0 p-0">
                        <NavLink
                          to="/multimedia"
                          className="link text-decoration-none"
                          href="#test"
                        >
                          {language.multimedia}
                        </NavLink>
                      </li>
                      <li className="list-group-item bg-transparent  border-0 p-0">
                        <NavLink
                          to="/contact"
                          className="link text-decoration-none"
                          href="#test"
                        >
                          {language.contactUs}
                        </NavLink>
                      </li>
                    </ul>
                  </Col>
                  <Col xl={4} lg={4} md={4} sm={6} xs={6} className="mt-4">
                    <h4 className="fw-normal text-black">
                      {language.importantLinks}
                    </h4>
                    <ul className="list-group">
                      {importantLinks.data.map((item) => (
                        <li
                          key={item.id}
                          className="list-group-item bg-transparent  border-0 p-0"
                        >
                          <NavLink
                            to={`/page/${item.link}`}
                            className="link text-decoration-none"
                            href="#test"
                          >
                            {item.title}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
          <Container fluid className="p-0 overflow-hidden">
            <Row className="border-top border-top border-light3 py-2">
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="text-center"
              >
                <h6 className="fw-bold text-light4 mw-100">
                  {language.copyright} © {new Date().getFullYear()}{" "}
                </h6>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </footer>
  );
}
